export const Close = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><circle fill="#1a1a1a" cx="2" cy="2" r="2"></circle><circle fill="#1a1a1a" cx="22" cy="2" r="2"></circle><circle fill="#1a1a1a" cx="2" cy="22" r="2"></circle><circle fill="#1a1a1a" cx="7" cy="17" r="2"></circle><circle fill="#1a1a1a" cx="12" cy="12" r="2"></circle><circle fill="#1a1a1a" cx="17" cy="7" r="2"></circle><circle fill="#1a1a1a" cx="22" cy="22" r="2"></circle><circle fill="#1a1a1a" cx="17" cy="17" r="2"></circle><circle fill="#1a1a1a" cx="7" cy="7" r="2"></circle></svg>);
}

export const Hamburger = () => {
  return (<svg version="1.1" x="0px" y="0px" width="30px" height="25px" viewBox="0 0 30 25" enableBackground="new 0 0 30 25"><path fill="none" stroke="#1A1A1A" d="M17.3,20.8c0-2-1.7-3.7-3.7-3.7s-3.7,1.7-3.7,3.7 M17.3,20.8c0,2-1.7,3.7-3.7,3.7 s-3.7-1.7-3.7-3.7 M17.3,20.8H30 M9.8,20.8H0 M26.3,12.5c0-2-1.7-3.7-3.7-3.7c-2.1,0-3.7,1.7-3.7,3.7 M26.3,12.5 c0,2-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7 M26.3,12.5H30 M18.8,12.5H0 M13.5,4.2c0-2-1.7-3.7-3.7-3.7S6.1,2.2,6.1,4.2 M13.5,4.2 c0,2-1.7,3.7-3.7,3.7S6.1,6.3,6.1,4.2 M13.5,4.2H30 M6.1,4.2H0"/></svg>); 
}

export const PriceSlash = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="42" height="20" viewBox="0 0 41.9 19.7">
      <path d="M0.1,19.7C13.6,12.9,27.3,7.2,41.8,3c0.3-0.1-0.2-2.9,0-3C27.3,4.2,13.6,9.9,0.1,16.7 C-0.3,16.9,0.5,19.5,0.1,19.7L0.1,19.7z" />
    </svg>
  );
};

export const Eye = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="19" height="15" viewBox="0 0 18.7 14.4">
      <g>
        <path d="M9.3,4.7C8,4.7,6.8,5.8,6.8,7.2c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5C11.8,5.8,10.7,4.7,9.3,4.7z" />
        <path
          d="M9.3,14.4c-5.1,0-8.8-4.7-9.3-7.2C0.6,4.7,4.2,0,9.3,0s8.8,4.7,9.3,7.2C18.1,9.7,14.5,14.4,9.3,14.4z M9.3,1 C5.2,1,1.8,4.6,1.1,7.1l0,0.1l0,0.1c0.7,2.5,4.1,6.1,8.3,6.1c4.1,0,7.5-3.6,8.3-6.1l0-0.1l0-0.1C16.9,4.6,13.5,1,9.3,1z"
        />
      </g>
    </svg>
  );
};

export const CircledArrowUp = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="41" height="41" viewBox="0 0 41 41">
      <g>
        <path class="arrow" d="M20.3,15.4l7.3,7.3L27,23.4l-6.7-6.7l-6.7,6.7L13,22.7L20.3,15.4z" />
      </g>
      <path
        class="circle"
        d="M20.5,40.5L20.5,40.5c-11,0-20-9-20-20v0c0-11,9-20,20-20h0c11,0,20,9,20,20v0C40.5,31.5,31.5,40.5,20.5,40.5z"
      />
    </svg>
  );
};

export const CircledArrowDown = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="41" height="41" viewBox="0 0 41 41">
      <g>
        <path class="arrow" d="M20.3,24.4L13,17l0.7-0.7l6.7,6.7l6.7-6.7l0.7,0.7L20.3,24.4z" />
      </g>
      <path
        class="circle"
        d="M20.5,40.5L20.5,40.5c-11,0-20-9-20-20v0c0-11,9-20,20-20h0c11,0,20,9,20,20v0C40.5,31.5,31.5,40.5,20.5,40.5z"
      />
    </svg>
  );
};

export const ArrowLeft = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="7" height="12" viewBox="0 0 6.5 12">
      <g>
        <path class="st0" d="M0,6l6-6l0.5,0.5L1.1,6l5.5,5.5L6,12L0,6z" />
      </g>
    </svg>
  );
};

export const ArrowRight = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="7" height="12" viewBox="0 0 6.5 12">
      <g>
        <path d="M6.5,6l-6,6L0,11.5L5.5,6L0,0.5L0.5,0L6.5,6z" />
      </g>
    </svg>
  );
};

export const ArrowDown = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="22" height="22" viewBox="0 0 22 12">
      <g>
        <path d="M11,12L0,1l1-1l10,10L21,0l1,1L11,12z" />
      </g>
    </svg>
  );
};

export const ArrowUp = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="22" height="22" viewBox="0 0 22 12">
      <g>
        <path d="M11,0l11,11l-1,1L11,2L1,12l-1-1L11,0z" />
      </g>
    </svg>
  );
};

export const Cross = () => {
  return (
    <svg version="1.1" x="0px" y="0px" width="42" height="42" viewBox="0 0 41.4 41.4">
      <line x1="0.7" y1="0.7" x2="40.7" y2="40.7" />
      <line x1="40.7" y1="0.7" x2="0.7" y2="40.7" />
    </svg>
  );
};

export const StarEmpty = () => {
  return (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 22 20.8" width="22" height="21">
      <path d="M11.1,4.6L12.8,8L13,8.5l0.5,0.1l3.8,0.6l-2.8,2.7l-0.3,0.3l0.1,0.5l0.7,3.8l-3.4-1.8l-0.5-0.2l-0.5,0.2 l-3.4,1.8l0.7-3.8l0.1-0.5l-0.4-0.4L4.7,9.1l3.8-0.6L9,8.4l0.2-0.5L11.1,4.6 M11.1,2.3L8.4,7.6L2.6,8.4l4.2,4.1l-1,5.8l5.2-2.7 l5.2,2.7l-1-5.8l4.2-4.1l-5.8-0.8L11.1,2.3L11.1,2.3z" />
    </svg>
  );
};

export const StarFilled = () => {
  return (
    <svg version="1.1" x="0px" y="0px" viewBox="0 0 22 20.8" width="22" height="21">
      <polygon points="11.1,2.3 13.7,7.6 19.5,8.4 15.3,12.6 16.3,18.4 11.1,15.7 5.8,18.4 6.8,12.6 2.6,8.4 8.4,7.6" />
    </svg>
  );
};

export const MapMarker = () => {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512"><path d="M256,0C167.641,0,96,71.625,96,160c0,24.75,5.625,48.219,15.672,69.125C112.234,230.313,256,512,256,512l142.594-279.375 C409.719,210.844,416,186.156,416,160C416,71.625,344.375,0,256,0z M256,256c-53.016,0-96-43-96-96s42.984-96,96-96 c53,0,96,43,96,96S309,256,256,256z"/></svg>
  );
};